export const testIds = {
  tripEtaSummaryNextStopInput: "trip-eta-summary-next-stop-input",
  tripEtaSummaryDeliveryInput: "trip-eta-summary-delivery-input",
} as const;
